import AuthService from "./auth.service";
import http from "./http-common";

const token = AuthService.getToken();

const getAllEvents = () => {
  return http.get("/Dashboard/GetEvents", {
    headers: { Authorization: "Bearer " + token },
  });
};

const addEvent = (data) => {
  return http.post("/Dashboard/AddEvent", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const getEventById = (data) => {
  return http.post("/Dashboard/GetEventbyid", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const updateEvent = (data) => {
  return http.post("/Dashboard/UpdateEvent", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const deleteEvent = (data) => {
  return http.post("/Dashboard/DeleteEvent", data, {
    headers: { Authorization: "Bearer " + token },
  });
};

const EventService = {
  getAllEvents,
  addEvent,
  getEventById,
  updateEvent,
  deleteEvent,
};

export default EventService;
